/**
 * 西班牙语（es）
 */
export default {
  PersonalCenter: {
    Store: {
      Index: {
        WhereToFind: 'Donde encontrar',
        Tips1: '1. Inicie sesión en wordpress para administrar backstage.',
        Tips2: '2. Vaya a: WooCommerce > Configuración > Avanzado > API REST > Clave de la aplicación.',
        Tips3: '3. Complete "Detalles clave"',
        Description: 'Descripción',
        Tips4: 'dale un nombre a la clave',
        User: 'Usuario',
        Tips5: 'seleccione el usuario de WooCommerce que será el autor de los cambios',
        Permissions: 'permisos',
        SelectReadWrite: 'Seleccione Leer/Escribir',
        SelectGenerateAPIKey: 'Seleccione Generar clave API',
        Tips6: '¿Aún estás confundido? Revisa la descripción del video.',
        Tips7: 'La edición de la información del producto solo se admite en la versión para computadora',
        StoreURL: 'URL de la tienda',
        StoreName: 'Nombre de la tienda',
        ConsumerKey: 'Clave de consumidor',
        ConsumerSecret: 'Secreto del consumidor',
        DefaultDomain: 'Dominio predeterminado',
        Tips8: "Puede ingresar letras en inglés, números, '-' y '_', comenzar y terminar con números o letras.",
        Tips9: 'Ingrese el nombre de su tienda.',
        Tips10: 'Ingrese la URL de su tienda',
        Tips11: 'Por favor ingrese la clave del consumidor',
        Tips12: 'Ingrese el secreto del consumidor',
        Tips13: 'Prueba interna de acoplamiento de la plataforma TikTok, así que estad atentos'
      },
      SetStore: {
        DefaultShippingMethod: 'Método de envío predeterminado',
        Standard: 'Estándar',
        Faster: 'Más rápido',
        Express: 'Expresar',
        Expedited: 'Acelerado',
        ProfitMargin: 'Margen de beneficio',
        Profit: 'Ganancia',
        orderCustomization: 'Utilice el método de envío del pedido original'
      }
    },
    Payment: {
      Index: {
        AvailableCredit: 'crédito disponible',
        CreditLimit: 'Límite de crédito',
        Tips1: 'Lo sentimos, aún no has tenido ninguna transacción.',
        Paypal: 'PayPal',
        Others: 'Otros',
        Tips2: 'Ingrese una cantidad entre 0 y 9999999, dos decimales permitidos.'
      },
      BankCard: {
        Tips1: 'El nuevo pedido de su tienda se pagará automáticamente utilizando el método de pago predeterminado en el archivo, y KakaClo lo cumplirá y lo enviará a sus clientes.',
        AddANewCard: 'Agregar una nueva tarjeta',
        Remove: 'Eliminar',
        Tips2: '¿Estás seguro de eliminar esta tarjeta bancaria?',
        Confirm: 'Confirmar',
        Cancel: 'Cancelar'
      },
      Components: {
        AirwallexCard: {
          CardNumber: 'Número de tarjeta',
          SecurityCode: 'Código de seguridad',
          ExpireDate: 'Fecha de caducidad',
          AcceptTheTerms: 'Aceptar los términos',
          Confirm: 'Confirmar'
        }
      }
    },
    MyInformation: {
      Index: {
        CompanyInformation: 'Información de la empresa',
        UNVERIFIEDBUYER: 'COMPRADOR NO VERIFICADO',
        Tips1: 'Cargue su permiso de vendedor para obtener acceso completo. Ver el requisito de su estado',
        Here: 'aquí',
        UnderReview: 'Bajo revisión',
        Tips2: 'Si ya cargó un permiso en esta página, espere 24 horas hábiles para que se revise su cuenta. Nos pondremos en contacto con usted por correo electrónico. Contáctenos a continuación si tiene dificultades para cargar a continuación.',
        AuditFailure: 'Fallo de auditoría',
        AuthenticatedBuyer: 'Comprador autenticado',
        Yes: 'Yes',
        No: 'No',
        Image: 'Imagen',
        DocumentOfProof: 'Documento de prueba',
        DocumentProofOfBusiness: 'Documento de prueba de negocio',
        Tips3: 'Cargue el permiso de vendedor. Encuentre los requisitos de su estado',
        Upload: 'Subir',
        UploadFormat: 'Formato de carga',
        CompanyAddress: 'Dirección de la empresa',
        SaveChanges: 'Guardar cambios',
        Address: 'DIRECCIÓN',
        City: 'Ciudad',
        StateProvince: 'Provincia del estado',
        ZIPPostalCode: 'Código postal/ZIP',
        Country: 'País',
        Phone: 'Teléfono',
        FirstName: 'Nombre de pila',
        LastName: 'Apellido',
        CompanyName: 'nombre de empresa',
        DoYouSellOnline: '¿Vendes en línea?',
        StoreURL: 'URL de la tienda',
        SellerPermitNumber: 'Número de permiso de vendedor',
        StorePicture: 'Imagen de la tienda',
        Tips4: 'Por favor, introduzca su nombre de pila',
        Tips5: 'Seleccione Sí o No',
        Tips6: 'Por favor ingrese su dirección',
        Tips7: 'Por favor ingrese su apellido',
        Tips8: 'Por favor ingrese el nombre de su empresa',
        Tips9: 'Por favor ingrese su ciudad',
        Tips10: 'Por favor seleccione el país',
        Tips11: 'Por favor ingrese no más de 20 caracteres',
        Tips12: '¡Guardar Cambio Exitoso!'
      }
    },
    Components: {
      Tips1: 'Asegúrese de haber obtenido los documentos adecuados para hacer negocios en su estado.',
      Tips2: 'Tenga en cuenta que el número de permiso de vendedor es diferente a un EIN. Si su estado le emite el mismo número, esté listo para proporcionarnos una copia de su certificado de reventa completado para demostrar que su empresa tiene permiso para revender compras al por mayor.',
      Tips3: 'Estados sin número de permiso de vendedor: Alaska, Delaware, Montana, New Hampshire, Oregón',
      Tips4: 'Encuentre los requisitos de su estado'
    },
    AccountSetting: {
      Index: {
        NotVerified: 'no verificado',
        ChangePassword: 'Cambiar la contraseña',
        Tips1: 'Se ha enviado un código de verificación a su correo electrónico.',
        Tips2: 'Se enviará un código de verificación a su correo electrónico.',
        Tips3: 'Puedes reenviar el código después',
        later: 'más tarde',
        Submit: 'Entregar',
        EMailVerification: 'Verificacion de email',
        FullName: 'Nombre completo',
        Email: 'Correo electrónico',
        Phone: 'Teléfono',
        Password: 'Contraseña',
        Tips4: 'Se ha enviado un código de verificación a su correo electrónico.',
        VerificationCode: 'Código de verificación',
        Send: 'Enviar',
        ConfirmPassword: 'confirmar Contraseña',
        Tips5: 'Por favor, introduzca su número de teléfono válido',
        Tips6: 'Por favor, introduzca la contraseña de nuevo',
        Tips7: '¡Las dos contraseñas son inconsistentes!',
        Tips8: 'Por favor ingrese el código de verificación'
      },
      Components: {
        AccountSettingDialog: {
          Tips1: 'Se ha enviado un código de verificación a su correo electrónico.',
          Tips2: 'Puedes reenviar el código después',
          later: 'más tarde',
          ChangePassword: 'Cambiar la contraseña',
          VerificationCode: 'Código de verificación',
          Password: 'Contraseña',
          ConfirmPassword: 'confirmar Contraseña',
          Tips3: 'Por favor, introduzca su número de teléfono válido',
          Tips4: 'Por favor, introduzca la contraseña de nuevo',
          Tips5: '¡Las dos contraseñas son inconsistentes!',
          Tips6: 'Por favor, introduzca la contraseña',
          Tips7: 'Haga clic para enviar el Código de verificación'
        }
      }
    },
    ApiSet: {
      Token: 'Simbólica',
      MaturityTime: 'Tiempo de madurez',
      Check: 'Controlar',
      RenewToken: 'Renovar token',
      Confirm: 'Confirmar',
      Cancel: 'Cancelar',
      hint1: 'Por favor, introduzca su contraseña de inicio de sesión',
      hint2: 'La clave se puede actualizar si el período de validez es inferior a 7 días.',
      APIDocument: 'API documento',
      SigningSecret: 'Secreto de firma',
      webHookHint1: 'Por favor ingrese su URL de devolución de llamada',
      Submit: 'Entregar',
      Show: 'Espectáculo',
      Hide: 'Esconder',
      webHookHint2: 'Por favor ingresa al sitio web que comienza con https'
    }
  }
}
